define('SuiteDynamics.PLPColorSwatches.ItemCell',
	[
		'underscore',
		'SC.Configuration',
		'SuiteDynamics.PLPColorSwatches.ItemCell.ColorOptions.View',
		'Facets.ItemCell.View'
	],
	function (
		_,
		SCConfiguration,
		ItemCellColorOptionsView,
		FacetsItemCellView
	)
{
	'use strict';

	FacetsItemCellView.prototype.initialize = _.wrap(FacetsItemCellView.prototype.initialize, function (fn) {
		fn.apply(this, _.toArray(arguments).slice(1));
		this.selectedColor = null;
		this.selectedColorId = null;

		this.model.on('change', this.render, this);
	});


	FacetsItemCellView.prototype.getContext = _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
		var originalContext = fn.apply(this, _.toArray(arguments).slice(1));

		var url = originalContext.url;
		var selectedColorId = this.selectedColorId || this.model.get('selectedColorId');
		var itemColorOptions = this.getItemColorOptions();

		if (selectedColorId && itemColorOptions && itemColorOptions.length) {
			_.each(itemColorOptions, function (colorOption) {
				if (colorOption.internalid === 'custcol6' && colorOption.values && colorOption.values.length) {
					var matchingValue = _.find(colorOption.values, function (value) {
						return value.internalid === String(selectedColorId);
					});

					if (matchingValue && matchingValue.url) {
						url = matchingValue.url;
					}
				}
			});
		}

		url = this.setDefaultItemOptions(url);

		return _.extend(originalContext, {
			url: url
		});
	});

	FacetsItemCellView.prototype.setDefaultItemOptions = function (url) {
		var visibleOptions = this.model.get('options').models;
		var requiredOptions = _.filter(visibleOptions, function (opt) {
			return opt.get('isMandatory') && opt.get('type') === 'select';
		});
		var isWomen = this.model.get('itemid') && this.model.get('itemid').toUpperCase()[0] === 'W';

		var urlParts = url.split('?');
		var baseUrl = urlParts[0];
		var queryString = urlParts[1] || '';
		var params = queryString ? queryString.split('&') : [];

		_.each(requiredOptions, function (requiredOption) {
			var currentValue = requiredOption.get('value');
			if (!currentValue || !currentValue.internalid) {
				var validValue;
				if ((requiredOption.get('urlParameterName') === 'size' || requiredOption.get('cartOptionId') === 'custcol5' || requiredOption.get('cartOptionId') === 'custcol77') &&
					requiredOption.get('values').length)
				{
					validValue = _.find(requiredOption.get('values'), function (val) {
						return val.isAvailable && parseInt(val.label) && (isWomen ? parseInt(val.label) === 8 : parseInt(val.label) === 11);
					});
				}

				if ((requiredOption.get('urlParameterName') === 'width' || requiredOption.get('cartOptionId') === 'custcol3') &&
					requiredOption.get('values').length)
				{
					validValue = _.find(requiredOption.get('values'), function (val) {
						return val.isAvailable && val.internalid && parseInt(val.internalid) === 2;
					});
				}

				if (!validValue) {
					validValue = _.find(requiredOption.get('values'), function (val) {
						return val.isAvailable && val.label.toLowerCase().indexOf('select') === -1;
					});
				}

				if (validValue && Object.keys(validValue).length) {
					var cartOptionId = requiredOption.get('urlParameterName') || requiredOption.get('cartOptionId');
					var valueInternalId = validValue.internalid;

					var alreadyParam = _.some(params, function (p) {
						return p.split('=')[0] === cartOptionId;
					});

					if (!alreadyParam) {
						params.push(cartOptionId + '=' + encodeURIComponent(valueInternalId));
					}
				}
			}
		}, this);

		var newQueryString = params.join('&');
		var newUrl = baseUrl + (newQueryString ? '?' + newQueryString : '');

		return newUrl;
	};

	FacetsItemCellView.prototype.getItemColorOptions = function() {
		var itemOptions = this.model.get('itemoptions_detail') && this.model.get('itemoptions_detail').fields || [];
		var itemColorOptionIds = SCConfiguration.get('plpColorSwatches.colorOptionIds', '').split(',');
		return _.filter(itemOptions, function(itemOption) {
			return itemOption.internalid && _.contains(itemColorOptionIds, itemOption.internalid);
		});
	}

	return {
		mountToApp: function mountToApp (container) {
			FacetsItemCellView.prototype.childViews = _.extend(FacetsItemCellView.prototype.childViews || {}, {
				'ItemCell.ColorOptions': function() {
					return new ItemCellColorOptionsView({
						model: this.model,
						itemCellView: this,
						selectedColor: this.selectedColor,
						selectedColorId: this.selectedColorId,
						container: container
					});
				}
			});
		}
	};
});
